import React from 'react'
import PropTypes from 'prop-types'
import Table from 'react-bootstrap/Table'
import { formatDateSlash } from 'helpers/datetime'

const formatNumber = (value) =>
  value === null || value === undefined ? '' : Number(value).toLocaleString()

const Meters = ({ meters }) => {
  return (
    <div className="w-100">
      <Table className="border border-light" size="sm">
        <thead className="border-bottom border-light">
          <tr>
            <th>Meter #</th>
            <th>Last Read</th>
            <th>Actual Read</th>
            <th>Usage</th>
            <th>Billed Usage</th>
            <th>Serial #</th>
            <th>Size</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          {meters.map((meter) => (
            <tr key={`meter-${meter.meter_det_key ?? meter.id}`}>
              <td>{meter.meter_det_key}</td>
              <td>{formatDateSlash(meter.meter_read_date)}</td>
              <td>{formatNumber(meter.actual_read)}</td>
              <td>{formatNumber(meter.actual_usage)}</td>
              <td>{formatNumber(meter.billed_usage)}</td>
              <td>{meter.serial_number}</td>
              <td>{meter.meter_size}</td>
              <td>{meter.meter_type}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

Meters.propTypes = {
  meters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      meter_det_key: PropTypes.number,
      meter_read_date: PropTypes.string,
      actual_read: PropTypes.number,
      actual_usage: PropTypes.number,
      billed_usage: PropTypes.number,
      serial_number: PropTypes.string,
      meter_size: PropTypes.string,
      meter_type: PropTypes.string
    })
  ).isRequired
}

export default Meters
